<template>
  <v-dialog
    v-model="dialogDeposit"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    width="700"
  >
    <v-card v-if="showingPromotionDetail === false" width="700" class="mx-auto">
      <ConfirmPromotionChangeDialog
        v-if="dialogConfirmPromotionChange"
        :dialog="dialogConfirmPromotionChange"
        :promotion="oldPromotion"
        :newPromotion="newPromotion"
        @closeDialog="dialogConfirmPromotionChange = false"
        @submit="submitDeposit"
      />

      <v-progress-linear
        v-if="
          promotions.promotionBeingChecked > 0 ||
          (promotions.items.length > 0 &&
            promotions.items[promoItemsIndexByPromoFilteredIndex]
              .withPromotionCode &&
            promotions.items[promoItemsIndexByPromoFilteredIndex].message
              .loading)
        "
        indeterminate
        color="primary"
      ></v-progress-linear>

      <v-toolbar fixed>
        <v-toolbar-title class="title">
          <span v-if="payment_providers.length == 0">
            {{ $t("tabDeposit") }}
          </span>
          <span v-else>
            {{ toolbarTitle }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-container>
        <!-- No payment methods found div -->
        <div
          v-if="payment_providers.length == 0 && paymentMethodsFetched"
          style="min-height: 300px"
          class="d-flex align-center pa-5"
        >
          <div class="d-flex flex-column justify-center align-center">
            <v-icon size="72">mdi-bank-off-outline</v-icon>
            <h2 class="text-center mt-5">
              {{ $t("noPaymentMethodsMsg") }}
            </h2>
          </div>
        </div>

        <!-- Div pai métodos & skeletons loading métodos -->
        <div v-else>
          <div
            v-if="payment_providers.length != 0 && !fetchingPromotions"
            class="d-flex flex-column justify-center"
          >
            <!-- Card do slide-group -->
            <v-card
              class="pa-4 mt-4 mx-auto grey darken-3"
              :class="{ 'mb-4': steps.paybrokers == 1 }"
            >
              <v-slide-group
                v-model="slideModel"
                center-active
                :show-arrows="isMobile"
                mandatory
              >
                <v-slide-item
                  v-for="method in payment_providers"
                  :key="method.uniqueId"
                  v-slot="{ active, toggle }"
                >
                  <v-card
                    :color="active ? '#ffffff' : 'grey lighten-1'"
                    class="d-flex justify-center align-center mx-2"
                    :class="active ? 'borderActiveMethodPay' : ''"
                    width="150px"
                    height="77px"
                    flat
                    @click="toggle"
                  >
                    <div class="d-flex flex-column justify-center align-center">
                      <img
                        :src="getMethodImage(method.uniqueId)"
                        width="70%"
                        :class="
                          method.uniqueId.includes('PixPaybrokers')
                            ? 'mt-2'
                            : ''
                        "
                      />
                    </div>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-card>

            <!-- PAY 4 FUN METHOD -->
            <div
              v-if="
                currentPaymentProvider == 'PixPay4FunGO' ||
                currentPaymentProvider == 'CarteiraPay4FunWallet'
              "
              :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
            >
              <div
                class="d-flex justify-center align-center flex-column mt-4"
                :style="$vuetify.breakpoint.mobile ? '' : ''"
              >
                <div style="width: 100%">
                  <v-scale-transition hide-on-leave>
                    <template>
                      <v-form
                        ref="form"
                        v-model="forms.pay4fun"
                        lazy-validation
                        @submit="preSubmit"
                      >
                        <v-card-text
                          class="px-6 mx-auto"
                          style="max-width: 400px"
                        >
                          <div class="d-flex justify-space-between mb-4">
                            <div>
                              {{ $t("minValueDialog") }}
                              {{ minPay4FunDeposit }}
                            </div>
                            <div>{{ $t("maxValueDialog") }} 30.000</div>
                          </div>
                          <div class="mb-2">
                            <v-text-field
                              id="scrollToPay4FunInput"
                              v-model="valueDeposit"
                              type="number"
                              placeholder="00,00"
                              :label="$t('infoValue')"
                              :prefix="$t('labelCurrency')"
                              outlined
                              class="grey--text"
                              hide-details="auto"
                              clearable
                              tabindex="2"
                              @click="scrollToInputValue()"
                              :rules="[
                                minDepositPay4FunRule,
                                maxDepositPay4FunRule,
                              ]"
                              :autofocus="$vuetify.breakpoint.lgAndUp"
                              onwheel="return false;"
                            ></v-text-field>

                            <div
                              class="d-flex justify-space-between mt-3"
                              v-if="
                                depositBonus.status &&
                                valueDeposit != '' &&
                                !disableDepositButton
                              "
                            >
                              <strong v-if="bonusValue > 0">
                                {{ $t("joinBonus") }}
                                <span style="color: LimeGreen">
                                  {{ $t("labelCurrency") }}
                                  {{ bonusValue }}
                                </span>
                              </strong>
                              <strong v-else class="text-uppercase">
                                {{ $t("roundsQuantity") }}:
                                <span style="color: LimeGreen">
                                  {{ depositQtyFreespins }}
                                </span>
                              </strong>
                            </div>
                          </div>

                          <div v-if="promotions.items.length > 0">
                            <div class="overline py-4 text-center">
                              {{ $t("promoCodeWithoutOptional") }}
                            </div>
                            <div
                              :class="
                                $vuetify.breakpoint.smAndDown ? '' : 'px-2'
                              "
                            >
                              <PromotionsRadioGroup
                                :promotions="promotions"
                                @showPromotionDetail="showPromotionDetail"
                                @updatePromotionCode="updatePromotionCode"
                                @clearBonusValue="clearBonusValue"
                                @clearPromotionCode="clearPromotionCode"
                                :hiddenPromotions="hiddenPromotions"
                                :slideModel="slideModel"
                                ref="promotions"
                              />
                            </div>
                          </div>

                          <span
                            v-if="currentPaymentProvider == 'PixPay4FunGO'"
                            class="subtitle-2"
                            style="text-align: center"
                            v-html="
                              $t('depositPaymentProviderRules.PixPay4Fun')
                            "
                          ></span>
                        </v-card-text>
                        <v-card-actions
                          class="pa-6 pt-0 mx-auto"
                          style="max-width: 400px"
                        >
                          <v-btn
                            :loading="loading"
                            tabindex="8"
                            block
                            type="submit"
                            class="primary darken-1"
                            @click.prevent="preSubmit"
                            :disabled="
                              disableDepositButton ||
                              disableSubmitButtonByPromotion ||
                              !forms.pay4fun ||
                              disablePay4FunDepositButton ||
                              loading
                            "
                          >
                            {{ $t("deposit") }}
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </template>
                  </v-scale-transition>
                </div>
              </div>
            </div>

            <!-- PAY BROKERS METHOD -->
            <div
              v-else-if="
                currentPaymentProvider === 'PixPaybrokers' ||
                currentPaymentProvider === 'PixPaybrokersV4'
              "
              class="d-flex justify-center align-center flex-column"
              :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
              :style="$vuetify.breakpoint.mobile ? '' : ''"
            >
              <div style="width: 100%">
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paybrokers == 1">
                    <v-form
                      ref="form"
                      v-model="forms.paybrokers"
                      lazy-validation
                      @submit="preSubmit"
                    >
                      <v-card-text
                        class="px-6 mx-auto"
                        style="max-width: 400px"
                      >
                        <div class="mb-2">
                          <v-text-field
                            id="scrollToPaybrokersValue"
                            v-model="valueDeposit"
                            type="number"
                            placeholder="00,00"
                            :label="$t('infoValue')"
                            :prefix="$t('labelCurrency')"
                            hide-details="auto"
                            outlined
                            class="grey--text"
                            clearable
                            tabindex="2"
                            @click="scrollToInputValue()"
                            :rules="[minDepositRule]"
                            :autofocus="$vuetify.breakpoint.lgAndUp"
                            onwheel="return false;"
                          ></v-text-field>

                          <div
                            class="d-flex justify-space-between mt-3"
                            v-if="
                              depositBonus.status &&
                              valueDeposit != '' &&
                              !disableDepositButton
                            "
                          >
                            <strong v-if="bonusValue > 0">
                              {{ $t("joinBonus") }}
                              <span style="color: LimeGreen">
                                {{ $t("labelCurrency") }}
                                {{ bonusValue }}
                              </span>
                            </strong>
                            <strong v-else class="text-uppercase">
                              {{ $t("roundsQuantity") }}:
                              <span style="color: LimeGreen">
                                {{ depositQtyFreespins }}
                              </span>
                            </strong>
                          </div>
                        </div>

                        <div v-if="promotions.items.length > 0">
                          <div class="overline py-4 text-center">
                            {{ $t("promoCodeWithoutOptional") }}
                          </div>
                          <div
                            :class="$vuetify.breakpoint.smAndDown ? '' : 'px-2'"
                          >
                            <PromotionsRadioGroup
                              :promotions="promotions"
                              @showPromotionDetail="showPromotionDetail"
                              @updatePromotionCode="updatePromotionCode"
                              @clearBonusValue="clearBonusValue"
                              :hiddenPromotions="hiddenPromotions"
                              :slideModel="slideModel"
                              ref="promotions"
                            />
                          </div>
                        </div>

                        <span
                          v-html="
                            $t(
                              'depositPaymentProviderRules.PixPaybrokersBrasilCash'
                            )
                          "
                        ></span>
                      </v-card-text>
                      <v-card-actions
                        class="pa-6 pt-0 mx-auto"
                        style="max-width: 400px"
                      >
                        <v-btn
                          :loading="loading"
                          tabindex="8"
                          block
                          type="submit"
                          class="primary darken-1"
                          @click.prevent="preSubmit"
                          :disabled="
                            disableSubmitButtonByPromotion ||
                            !forms.paybrokers ||
                            disableDepositButton ||
                            loading
                          "
                        >
                          {{ $t("btnPix") }}
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paybrokers == 2">
                    <v-card-text
                      class="px-6 mx-auto mt-4 mb-6"
                      style="max-width: 400px"
                    >
                      <div class="mt-4">
                        <p class="white--text body-1">
                          {{ $t("paymentText") }}
                        </p>
                        <div class="my-4 white--text body-1">
                          {{ $t("depositValue") }} {{ feedbackDeposit }}
                        </div>
                      </div>
                      <v-btn
                        block
                        @click="$copy(code)"
                        color="primary"
                        class="mb-4"
                      >
                        <v-icon small left>mdi-content-copy</v-icon>
                        {{ $t("pixCopyPaste") }}
                      </v-btn>
                      <div class="d-flex subtitle-1 justify-start align-center">
                        <v-divider class="mr-4"></v-divider>
                        <div>{{ $t("particleOr") }}</div>
                        <v-divider class="ml-4"></v-divider>
                      </div>
                      <div class="mx-auto mt-2" style="width: 250px">
                        <v-img
                          :src="Qrcode"
                          max-height="200px"
                          max-width="200px"
                          class="mx-auto"
                        ></v-img>
                        <v-btn
                          @click="balanceOnline"
                          block
                          class="mt-6"
                          color="green"
                          :disabled="loadingConfirmDeposit"
                        >
                          {{ $t("confirmPayment") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paybrokers == 3">
                    <v-card-text
                      class="px-6 mx-auto mt-10"
                      style="max-width: 600px"
                    >
                      <div
                        class="d-flex flex-column align-center"
                        :class="isXsmall ? 'pa-4' : 'pa-10'"
                      >
                        <v-icon color="green" class="mb-6" size="80"
                          >mdi-checkbox-marked-circle-outline</v-icon
                        >
                        <div class="title white--text">
                          {{ $t("depositConfirmed") }}
                        </div>
                        <div class="subtitle-1 text-center">
                          {{ $t("congratsDeposit") }}
                        </div>
                        <div
                          class="d-flex flex-column"
                          :style="isXsmall ? '' : 'width: 60%'"
                        >
                          <v-btn
                            @click="steps.paybrokers = 1"
                            class="mt-6"
                            color="green"
                          >
                            {{ $t("newDeposit") }}
                          </v-btn>
                          <v-btn
                            v-if="showRedirectToMyPromotionsButton"
                            class="mt-6 px-3"
                            color="primary"
                            :disabled="loadingConfirmDeposit"
                            @click="redirectToMyPromotionsFreespins"
                          >
                            {{ $t("goToMyPromotions") }}
                          </v-btn>
                        </div>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
              </div>
            </div>

            <!-- PAY BRASILCASH METHOD -->
            <div v-else-if="currentPaymentProvider === 'PixBrasilCash'">
              <div
                class="d-flex justify-center align-center flex-column mt-4"
                :style="$vuetify.breakpoint.mobile ? '' : ''"
              >
                <div style="width: 100%">
                  <v-scale-transition hide-on-leave>
                    <template v-if="steps.brasilcash == 1">
                      <v-form
                        ref="form"
                        v-model="forms.brasilcash"
                        lazy-validation
                        @submit="preSubmit"
                      >
                        <v-card-text
                          class="px-6 mx-auto"
                          style="max-width: 400px"
                        >
                          <div class="mb-2">
                            <v-text-field
                              id="scrollToBrasilCashInput"
                              v-model="valueDeposit"
                              type="number"
                              placeholder="00,00"
                              :label="$t('infoValue')"
                              :prefix="$t('labelCurrency')"
                              outlined
                              class="grey--text"
                              hide-details="auto"
                              clearable
                              tabindex="2"
                              @click="scrollToInputValue()"
                              :rules="[minDepositRule]"
                              :autofocus="$vuetify.breakpoint.lgAndUp"
                              onwheel="return false;"
                            ></v-text-field>

                            <div
                              class="d-flex justify-space-between mt-3"
                              v-if="
                                depositBonus.status &&
                                valueDeposit != '' &&
                                !disableDepositButton
                              "
                            >
                              <strong v-if="bonusValue > 0">
                                {{ $t("joinBonus") }}
                                <span style="color: LimeGreen">
                                  {{ $t("labelCurrency") }}
                                  {{ bonusValue }}
                                </span>
                              </strong>
                              <strong v-else class="text-uppercase">
                                {{ $t("roundsQuantity") }}:
                                <span style="color: LimeGreen">
                                  {{ depositQtyFreespins }}
                                </span>
                              </strong>
                            </div>
                          </div>

                          <div v-if="promotions.items.length > 0">
                            <div class="overline py-4 text-center">
                              {{ $t("promoCodeWithoutOptional") }}
                            </div>
                            <div
                              :class="
                                $vuetify.breakpoint.smAndDown ? '' : 'px-2'
                              "
                            >
                              <PromotionsRadioGroup
                                :promotions="promotions"
                                @showPromotionDetail="showPromotionDetail"
                                @updatePromotionCode="updatePromotionCode"
                                @clearBonusValue="clearBonusValue"
                                :hiddenPromotions="hiddenPromotions"
                                :slideModel="slideModel"
                                ref="promotions"
                              />
                            </div>
                          </div>

                          <span
                            v-html="
                              $t(
                                'depositPaymentProviderRules.PixPaybrokersBrasilCash'
                              )
                            "
                          ></span>
                        </v-card-text>
                        <v-card-actions
                          class="pa-6 pt-0 mx-auto"
                          style="max-width: 400px"
                        >
                          <v-btn
                            :loading="loading"
                            tabindex="8"
                            block
                            type="submit"
                            class="primary darken-1"
                            @click.prevent="preSubmit"
                            :disabled="
                              disableSubmitButtonByPromotion ||
                              !forms.brasilcash ||
                              disableDepositButton ||
                              loading
                            "
                          >
                            {{ $t("deposit") }}
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </template>
                  </v-scale-transition>
                  <v-scale-transition hide-on-leave>
                    <template v-if="steps.brasilcash == 2">
                      <v-card-text
                        class="px-6 mx-auto mt-4 mb-6"
                        style="max-width: 400px"
                      >
                        <div class="mt-4">
                          <p class="white--text body-1">
                            {{ $t("paymentText") }}
                          </p>
                          <div class="my-4 white--text body-1">
                            {{ $t("depositValue") }} {{ feedbackDeposit }}
                          </div>
                        </div>
                        <v-btn
                          block
                          @click="$copy(code)"
                          color="primary"
                          class="mb-4"
                        >
                          <v-icon small left>mdi-content-copy</v-icon>
                          {{ $t("pixCopyPaste") }}
                        </v-btn>
                        <div
                          class="d-flex subtitle-1 justify-start align-center"
                        >
                          <v-divider class="mr-4"></v-divider>
                          <div>{{ $t("particleOr") }}</div>
                          <v-divider class="ml-4"></v-divider>
                        </div>
                        <div class="mx-auto mt-2" style="width: 250px">
                          <v-img
                            :src="Qrcode"
                            max-height="200px"
                            max-width="200px"
                            class="mx-auto"
                          ></v-img>
                          <v-btn
                            @click="balanceOnline"
                            block
                            class="mt-6"
                            color="green"
                            :disabled="loadingConfirmDeposit"
                          >
                            {{ $t("confirmPayment") }}
                            <v-spacer v-if="loadingConfirmDeposit" />
                            <v-progress-circular
                              v-if="loadingConfirmDeposit"
                              :size="18"
                              indeterminate
                            ></v-progress-circular>
                          </v-btn>
                        </div>
                      </v-card-text>
                    </template>
                  </v-scale-transition>
                  <v-scale-transition hide-on-leave>
                    <template v-if="steps.brasilcash == 3">
                      <v-card-text
                        class="px-6 mx-auto mt-10"
                        style="max-width: 600px"
                      >
                        <div class="text-center pa-10">
                          <v-icon color="green" class="mb-6" size="80"
                            >mdi-checkbox-marked-circle-outline</v-icon
                          >
                          <div class="title white--text">
                            {{ $t("depositConfirmed") }}
                          </div>
                          <div class="subtitle-1">
                            {{ $t("congratsDeposit") }}
                          </div>
                          <v-btn
                            @click="steps.brasilcash = 1"
                            class="my-4"
                            color="green"
                          >
                            {{ $t("newDeposit") }}
                          </v-btn>
                          <v-btn
                            v-if="showRedirectToMyPromotionsButton"
                            class="mt-6 px-3"
                            color="primary"
                            :disabled="loadingConfirmDeposit"
                            @click="redirectToMyPromotionsFreespins"
                          >
                            {{ $t("goToMyPromotions") }}
                          </v-btn>
                        </div>
                      </v-card-text>
                    </template>
                  </v-scale-transition>
                </div>
              </div>
            </div>

            <!-- PAY LANCEWALLET PIX METHOD -->
            <div
              v-else-if="currentPaymentProvider === 'PixLanceCerto'"
              class="d-flex justify-center align-center flex-column"
              :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
            >
              <div style="width: 100%">
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.lancecerto == 1">
                    <v-form
                      ref="form"
                      v-model="forms.lancecerto"
                      lazy-validation
                      @submit="preSubmit"
                    >
                      <v-card-text
                        class="px-6 mx-auto"
                        style="max-width: 400px"
                      >
                        <div class="mb-2">
                          <v-text-field
                            id="scrollToLanceCertoValue"
                            v-model="valueDeposit"
                            type="number"
                            placeholder="00,00"
                            :label="$t('infoValue')"
                            :prefix="$t('labelCurrency')"
                            hide-details="auto"
                            outlined
                            class="grey--text"
                            clearable
                            tabindex="2"
                            @click="scrollToInputValue()"
                            :rules="[minDepositRule]"
                            :autofocus="$vuetify.breakpoint.lgAndUp"
                            onwheel="return false;"
                          ></v-text-field>

                          <div
                            class="d-flex justify-space-between mt-3"
                            v-if="
                              depositBonus.status &&
                              valueDeposit != '' &&
                              !disableDepositButton
                            "
                          >
                            <strong v-if="bonusValue > 0">
                              {{ $t("joinBonus") }}
                              <span style="color: LimeGreen">
                                {{ $t("labelCurrency") }}
                                {{ bonusValue }}
                              </span>
                            </strong>
                            <strong v-else class="text-uppercase">
                              {{ $t("roundsQuantity") }}:
                              <span style="color: LimeGreen">
                                {{ depositQtyFreespins }}
                              </span>
                            </strong>
                          </div>
                        </div>

                        <div v-if="promotions.items.length > 0">
                          <div class="overline py-4 text-center">
                            {{ $t("promoCodeWithoutOptional") }}
                          </div>
                          <div
                            :class="$vuetify.breakpoint.smAndDown ? '' : 'px-2'"
                          >
                            <PromotionsRadioGroup
                              :promotions="promotions"
                              @showPromotionDetail="showPromotionDetail"
                              @updatePromotionCode="updatePromotionCode"
                              @clearBonusValue="clearBonusValue"
                              :hiddenPromotions="hiddenPromotions"
                              :slideModel="slideModel"
                              ref="promotions"
                            />
                          </div>
                        </div>

                        <span
                          v-html="
                            $t(
                              'depositPaymentProviderRules.PixPaybrokersBrasilCash'
                            )
                          "
                        ></span>
                      </v-card-text>
                      <v-card-actions
                        class="pa-6 pt-0 mx-auto"
                        style="max-width: 400px"
                      >
                        <v-btn
                          :loading="loading"
                          tabindex="8"
                          block
                          type="submit"
                          class="primary darken-1"
                          @click.prevent="preSubmit"
                          :disabled="
                            disableSubmitButtonByPromotion ||
                            !forms.lancecerto ||
                            disableDepositButton ||
                            loading
                          "
                        >
                          {{ $t("btnPix") }}
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.lancecerto == 2">
                    <v-card-text
                      class="px-6 mx-auto mt-4 mb-6"
                      style="max-width: 400px"
                    >
                      <div class="mt-4">
                        <p class="white--text body-1">
                          {{ $t("paymentText") }}
                        </p>
                        <div class="my-4 white--text body-1">
                          {{ $t("depositValue") }} {{ feedbackDeposit }}
                        </div>
                      </div>
                      <v-btn
                        block
                        @click="$copy(code)"
                        color="primary"
                        class="mb-4"
                      >
                        <v-icon small left>mdi-content-copy</v-icon>
                        {{ $t("pixCopyPaste") }}
                      </v-btn>
                      <div class="d-flex subtitle-1 justify-start align-center">
                        <v-divider class="mr-4"></v-divider>
                        <div>{{ $t("particleOr") }}</div>
                        <v-divider class="ml-4"></v-divider>
                      </div>
                      <div class="mx-auto mt-2" style="width: 250px">
                        <v-img
                          :src="Qrcode"
                          max-height="200px"
                          max-width="200px"
                          class="mx-auto"
                        ></v-img>
                        <v-btn
                          @click="balanceOnline"
                          block
                          class="mt-6"
                          color="green"
                          :disabled="loadingConfirmDeposit"
                        >
                          {{ $t("confirmPayment") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.lancecerto == 3">
                    <v-card-text
                      class="px-6 mx-auto mt-10"
                      style="max-width: 600px"
                    >
                      <div class="text-center pa-10">
                        <v-icon color="green" class="mb-6" size="80"
                          >mdi-checkbox-marked-circle-outline</v-icon
                        >
                        <div class="title white--text">
                          {{ $t("depositConfirmed") }}
                        </div>
                        <div class="subtitle-1">
                          {{ $t("congratsDeposit") }}
                        </div>
                        <v-btn
                          @click="steps.lancecerto = 1"
                          class="my-4"
                          color="green"
                        >
                          {{ $t("newDeposit") }}
                        </v-btn>
                        <v-btn
                          v-if="showRedirectToMyPromotionsButton"
                          class="mt-6 px-3"
                          color="primary"
                          :disabled="loadingConfirmDeposit"
                          @click="redirectToMyPromotionsFreespins"
                        >
                          {{ $t("goToMyPromotions") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
              </div>
            </div>

            <!-- CLINPAYS METHOD -->
            <div
              v-if="currentPaymentProvider == 'CartãoClinPays'"
              :class="$vuetify.breakpoint.mobile ? 'my-4' : ''"
            >
              <div
                v-if="gettingListCards"
                style="height: 400px"
                class="d-flex justify-center align-center"
              >
                <v-progress-circular
                  :size="100"
                  :width="7"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
              <div v-else>
                <div>
                  <div style="width: 100%">
                    <v-scale-transition hide-on-leave>
                      <template v-if="steps.clinPays == 1">
                        <v-form
                          ref="form"
                          v-model="forms.clinPays"
                          @submit="preSubmit"
                        >
                          <!-- registerCard -->
                          <v-card-text
                            class="px-6 mx-auto"
                            style="max-width: 466px"
                          >
                            <div v-if="registerCard">
                              <div class="mb-4" id="scrollToNumberCart">
                                <span class="mb-0">{{ $t("cardNumber") }}</span>
                                <v-text-field
                                  v-model="number_cart"
                                  type="text"
                                  dense
                                  :placeholder="$t('cardNumber')"
                                  v-mask="creditCardMask"
                                  outlined
                                  onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                                  class="grey--text"
                                  hide-details="auto"
                                  tabindex="2"
                                  :autofocus="registeringNewCard"
                                  :rules="[
                                    rules.required,
                                    rules.validateCreditCardNumber,
                                  ]"
                                >
                                  <template v-slot:append>
                                    <img
                                      v-if="icon && icon.length > 3"
                                      width="24"
                                      height="24"
                                      :src="iconSrc"
                                    />

                                    <v-icon v-else size="24">
                                      mdi-credit-card
                                    </v-icon>
                                  </template>
                                </v-text-field>
                              </div>
                              <div class="mb-4 row">
                                <div class="col-6">
                                  <span class="mb-0">{{
                                    $t("cardValidity")
                                  }}</span>
                                  <v-text-field
                                    v-model="validate_cart"
                                    type="text"
                                    v-mask="'##/##'"
                                    dense
                                    placeholder="MM/AA"
                                    outlined
                                    class="grey--text"
                                    hide-details="auto"
                                    clearable
                                    tabindex="2"
                                    :rules="[
                                      rules.required,
                                      rules.wrongValidateCart,
                                    ]"
                                  ></v-text-field>
                                </div>
                                <div class="col-6">
                                  <div>
                                    <!-- div do CVV tooltip mobile -->
                                    <div
                                      v-if="showtooltiptext"
                                      class="tooltip d-flex justify-end"
                                      style="width: 100%"
                                    >
                                      <div class="tooltiptext">
                                        <span class="">{{
                                          $t("cvvTooltipText")
                                        }}</span>
                                      </div>
                                    </div>

                                    <div class="d-flex justify-space-between">
                                      <div>
                                        <span class="mb-0">{{
                                          $t("securityCode")
                                        }}</span>
                                      </div>
                                      <div v-if="$vuetify.breakpoint.smAndUp">
                                        <v-tooltip top>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                            style="width: 150px"
                                          >
                                            <v-btn
                                              icon
                                              x-small
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon small
                                                >mdi-information-outline</v-icon
                                              >
                                            </v-btn>
                                          </template>
                                          <span>{{
                                            $t("cvvTooltipText")
                                          }}</span>
                                        </v-tooltip>
                                      </div>
                                    </div>
                                  </div>
                                  <v-text-field
                                    v-model="cvv_cart"
                                    type="text"
                                    v-mask="cvvMask"
                                    placeholder="CVV"
                                    outlined
                                    dense
                                    :append-icon="
                                      $vuetify.breakpoint.xs
                                        ? 'mdi-information-outline'
                                        : ''
                                    "
                                    @click:append="tooltipText()"
                                    class="grey--text"
                                    hide-details="auto"
                                    clearable
                                    tabindex="2"
                                    :rules="[rules.cvvDigitsCount]"
                                  >
                                  </v-text-field>
                                </div>
                              </div>
                            </div>
                            <!-- registerCard end -->

                            <!-- hasCard -->
                            <div v-if="hasCard">
                              <div class="d-flex align-center mb-4 ml-3">
                                <v-radio-group
                                  mandatory
                                  v-model="SelectedClinPaysCard"
                                >
                                  <v-radio
                                    v-for="(card, index) in cardsList"
                                    :key="card + index"
                                    :label="card.safeIdentifier"
                                    :value="card"
                                  >
                                    <template v-slot:label>
                                      <div class="d-flex align-center">
                                        <div class="title">
                                          <span>{{ card.safeIdentifier }}</span>
                                        </div>
                                        <div class="pl-4">
                                          <template>
                                            <img
                                              v-if="card.brand == 'MASTERCARD'"
                                              width="28"
                                              height="28"
                                              src="../../../src/assets/credit-cards-flags/mastercard.svg"
                                            />
                                            <img
                                              v-else-if="card.brand == 'VISA'"
                                              width="28"
                                              height="28"
                                              src="../../../src/assets/credit-cards-flags/visa.svg"
                                            />
                                            <img
                                              v-else-if="card.brand == 'AMEX'"
                                              width="28"
                                              height="28"
                                              src="../../../src/assets/credit-cards-flags/amex.svg"
                                            />
                                            <v-icon v-else
                                              >mdi-credit-card</v-icon
                                            >
                                          </template>
                                        </div>
                                      </div>
                                    </template>
                                  </v-radio>
                                </v-radio-group>
                              </div>
                            </div>
                            <!-- hasCard end -->
                            <div class="mb-2">
                              <v-text-field
                                id="scrollToClinPaysInput"
                                v-model="valueDeposit"
                                type="number"
                                placeholder="00,00"
                                :label="$t('infoValue')"
                                :prefix="$t('labelCurrency')"
                                outlined
                                dense
                                class="grey--text"
                                hide-details="auto"
                                :rules="[minDepositRule]"
                                clearable
                                tabindex="2"
                                @click="scrollToInputValue()"
                                onwheel="return false;"
                              >
                              </v-text-field>

                              <div
                                class="d-flex justify-space-between mt-3"
                                v-if="
                                  depositBonus.status &&
                                  valueDeposit != '' &&
                                  !disableDepositButton
                                "
                              >
                                <strong v-if="bonusValue > 0">
                                  {{ $t("joinBonus") }}
                                  <span style="color: LimeGreen">
                                    {{ $t("labelCurrency") }}
                                    {{ bonusValue }}
                                  </span>
                                </strong>
                                <strong v-else class="text-uppercase">
                                  {{ $t("roundsQuantity") }}:
                                  <span style="color: LimeGreen">
                                    {{ depositQtyFreespins }}
                                  </span>
                                </strong>
                              </div>
                            </div>

                            <div v-if="promotions.items.length > 0">
                              <div class="overline py-4 text-center">
                                {{ $t("promoCodeWithoutOptional") }}
                              </div>
                              <div
                                :class="
                                  $vuetify.breakpoint.smAndDown ? '' : 'px-2'
                                "
                              >
                                <PromotionsRadioGroup
                                  :promotions="promotions"
                                  @showPromotionDetail="showPromotionDetail"
                                  @updatePromotionCode="updatePromotionCode"
                                  @clearBonusValue="clearBonusValue"
                                  :hiddenPromotions="hiddenPromotions"
                                  :slideModel="slideModel"
                                  ref="promotions"
                                />
                              </div>
                            </div>

                            <div
                              v-if="registerCard"
                              class="d-flex align-center"
                              style="cursor: pointer"
                              @click="saveCard = !saveCard"
                            >
                              <v-checkbox :input-value="saveCard"> </v-checkbox>
                              <span>{{ $t("saveCardText") }}</span>
                            </div>
                          </v-card-text>
                          <v-card-actions
                            class="pa-6 pt-0 mx-auto"
                            style="max-width: 466px"
                          >
                            <div class="row">
                              <div style="width: 100%">
                                <div class="mb-6">
                                  <v-btn
                                    :loading="loading"
                                    tabindex="8"
                                    block
                                    type="submit"
                                    class="primary"
                                    @click.prevent="preSubmit"
                                    :disabled="!forms.clinPays || loading"
                                  >
                                    {{ $t("deposit") }}
                                  </v-btn>
                                </div>
                              </div>
                              <div v-if="hasCard" style="width: 100%">
                                <div class="mb-6">
                                  <v-btn
                                    tabindex="8"
                                    color="primary"
                                    outlined
                                    block
                                    type="submit"
                                    :disabled="loading"
                                    @click="useAnotherCard()"
                                  >
                                    {{ $t("userAnotherCard") }}
                                  </v-btn>
                                </div>
                              </div>
                              <!-- goBack hasCard -->
                              <div
                                v-if="registerCard && registeringNewCard"
                                style="width: 100%"
                              >
                                <div class="">
                                  <v-btn
                                    tabindex="8"
                                    outlined
                                    block
                                    color="primary"
                                    @click="previous()"
                                  >
                                    {{ $t("goBack") }}
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </v-card-actions>
                        </v-form>
                      </template>
                    </v-scale-transition>
                    <v-scale-transition hide-on-leave>
                      <template v-if="steps.clinPays == 2">
                        <v-card-text
                          class="px-6 mx-auto mt-10"
                          style="max-width: 600px"
                        >
                          <div class="text-center pa-10">
                            <v-icon color="green" class="mb-6" size="80"
                              >mdi-checkbox-marked-circle-outline</v-icon
                            >
                            <div class="title white--text">
                              {{ $t("depositClinPaysConfirmed") }}
                            </div>
                            <div class="subtitle-1">
                              {{ $t("congratsDeposit") }}
                            </div>
                            <!-- aquii -->
                            <v-btn
                              @click="newDepositClinPays()"
                              class="my-4"
                              color="green"
                              >{{ $t("newDeposit") }}</v-btn
                            >
                          </div>
                        </v-card-text>
                      </template>
                    </v-scale-transition>
                  </div>
                </div>
              </div>
            </div>

            <!-- PAAG METHOD -->
            <div v-else-if="currentPaymentProvider === 'PixPaag'">
              <div style="width: 100%">
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paag == 1">
                    <v-form
                      ref="form"
                      v-model="forms.paag"
                      lazy-validation
                      @submit="preSubmit"
                    >
                      <v-card-text
                        class="px-6 mx-auto"
                        style="max-width: 400px"
                      >
                        <div class="mb-2">
                          <v-text-field
                            id="scrollToPaagValue"
                            v-model="valueDeposit"
                            type="number"
                            placeholder="00,00"
                            :label="$t('infoValue')"
                            :prefix="$t('labelCurrency')"
                            hide-details="auto"
                            outlined
                            class="grey--text"
                            clearable
                            tabindex="2"
                            @click="scrollToInputValue()"
                            :rules="[minDepositRule]"
                            :autofocus="$vuetify.breakpoint.lgAndUp"
                            onwheel="return false;"
                          ></v-text-field>

                          <div
                            class="d-flex justify-space-between mt-3"
                            v-if="
                              depositBonus.status &&
                              valueDeposit != '' &&
                              !disableDepositButton
                            "
                          >
                            <strong v-if="bonusValue > 0">
                              {{ $t("joinBonus") }}
                              <span style="color: LimeGreen">
                                {{ $t("labelCurrency") }}
                                {{ bonusValue }}
                              </span>
                            </strong>
                            <strong v-else class="text-uppercase">
                              {{ $t("roundsQuantity") }}:
                              <span style="color: LimeGreen">
                                {{ depositQtyFreespins }}
                              </span>
                            </strong>
                          </div>
                        </div>

                        <div v-if="promotions.items.length > 0">
                          <div class="overline py-4 text-center">
                            {{ $t("promoCodeWithoutOptional") }}
                          </div>
                          <div
                            :class="$vuetify.breakpoint.smAndDown ? '' : 'px-2'"
                          >
                            <PromotionsRadioGroup
                              :promotions="promotions"
                              @showPromotionDetail="showPromotionDetail"
                              @updatePromotionCode="updatePromotionCode"
                              @clearBonusValue="clearBonusValue"
                              :hiddenPromotions="hiddenPromotions"
                              :slideModel="slideModel"
                              ref="promotions"
                            />
                          </div>
                        </div>

                        <span
                          v-html="
                            $t(
                              'depositPaymentProviderRules.PixPaybrokersBrasilCash'
                            )
                          "
                        ></span>
                      </v-card-text>
                      <v-card-actions
                        class="pa-6 pt-0 mx-auto"
                        style="max-width: 400px"
                      >
                        <v-btn
                          :loading="loading"
                          tabindex="8"
                          block
                          type="submit"
                          class="primary darken-1"
                          @click.prevent="preSubmit"
                          :disabled="
                            disableSubmitButtonByPromotion ||
                            !forms.paag ||
                            disableDepositButton ||
                            loading
                          "
                        >
                          {{ $t("btnPix") }}
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paag == 2">
                    <v-card-text
                      class="px-6 mx-auto mt-4 mb-6"
                      style="max-width: 400px"
                    >
                      <div class="mt-4">
                        <p class="white--text body-1">
                          {{ $t("paymentText") }}
                        </p>
                        <div class="my-4 white--text body-1">
                          {{ $t("depositValue") }} {{ feedbackDeposit }}
                        </div>
                      </div>
                      <v-btn
                        block
                        @click="$copy(code)"
                        color="primary"
                        class="mb-4"
                      >
                        <v-icon small left>mdi-content-copy</v-icon>
                        {{ $t("pixCopyPaste") }}
                      </v-btn>
                      <div class="d-flex subtitle-1 justify-start align-center">
                        <v-divider class="mr-4"></v-divider>
                        <div>{{ $t("particleOr") }}</div>
                        <v-divider class="ml-4"></v-divider>
                      </div>
                      <div class="mx-auto mt-2" style="width: 250px">
                        <v-img
                          :src="Qrcode"
                          max-height="200px"
                          max-width="200px"
                          class="mx-auto"
                          style="background: white !important"
                        ></v-img>
                        <v-btn
                          @click="balanceOnline"
                          block
                          class="mt-6"
                          color="green"
                          :disabled="loadingConfirmDeposit"
                        >
                          {{ $t("confirmPayment") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paag == 3">
                    <v-card-text
                      class="px-6 mx-auto mt-10"
                      style="max-width: 600px"
                    >
                      <div class="text-center pa-10">
                        <v-icon color="green" class="mb-6" size="80">
                          mdi-checkbox-marked-circle-outline
                        </v-icon>
                        <div class="title white--text">
                          {{ $t("depositConfirmed") }}
                        </div>
                        <div class="subtitle-1">
                          {{ $t("congratsDeposit") }}
                        </div>
                        <v-btn
                          @click="steps.paag = 1"
                          class="my-4"
                          color="green"
                        >
                          {{ $t("newDeposit") }}
                        </v-btn>
                        <v-btn
                          v-if="showRedirectToMyPromotionsButton"
                          class="mt-6 px-3"
                          color="primary"
                          :disabled="loadingConfirmDeposit"
                          @click="redirectToMyPromotionsFreespins"
                        >
                          {{ $t("goToMyPromotions") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
              </div>
            </div>

            <!-- PAGUE PAY METHOD -->
            <div v-else-if="currentPaymentProvider === 'PixPaguePay'">
              <div style="width: 100%">
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paguePay == 1">
                    <v-form
                      ref="form"
                      v-model="forms.paguePay"
                      lazy-validation
                      @submit="preSubmit"
                    >
                      <v-card-text
                        class="px-6 mx-auto"
                        style="max-width: 400px"
                      >
                        <div class="mb-2">
                          <v-text-field
                            id="scrollToPaguePayInput"
                            v-model="valueDeposit"
                            type="number"
                            placeholder="00,00"
                            :label="$t('infoValue')"
                            :prefix="$t('labelCurrency')"
                            hide-details="auto"
                            outlined
                            class="grey--text"
                            clearable
                            tabindex="2"
                            @click="scrollToInputValue()"
                            :rules="[minDepositRule]"
                            :autofocus="$vuetify.breakpoint.lgAndUp"
                            onwheel="return false;"
                          ></v-text-field>
                          <div
                            class="d-flex justify-space-between mt-3"
                            v-if="
                              depositBonus.status &&
                              valueDeposit != '' &&
                              !disableDepositButton
                            "
                          >
                            <strong v-if="bonusValue > 0">
                              {{ $t("joinBonus") }}
                              <span style="color: LimeGreen">
                                {{ $t("labelCurrency") }}
                                {{ bonusValue }}
                              </span>
                            </strong>
                            <strong v-else class="text-uppercase">
                              {{ $t("roundsQuantity") }}:
                              <span style="color: LimeGreen">
                                {{ depositQtyFreespins }}
                              </span>
                            </strong>
                          </div>
                        </div>

                        <div v-if="promotions.items.length > 0">
                          <div class="overline py-4 text-center">
                            {{ $t("promoCodeWithoutOptional") }}
                          </div>
                          <div
                            :class="$vuetify.breakpoint.smAndDown ? '' : 'px-2'"
                          >
                            <PromotionsRadioGroup
                              :promotions="promotions"
                              @showPromotionDetail="showPromotionDetail"
                              @updatePromotionCode="updatePromotionCode"
                              @clearBonusValue="clearBonusValue"
                              :hiddenPromotions="hiddenPromotions"
                              :slideModel="slideModel"
                              ref="promotions"
                            />
                          </div>
                        </div>

                        <div>
                          <span
                            v-html="
                              $t('depositPaymentProviderRules.PixPaguePay')
                            "
                          ></span>
                        </div>
                      </v-card-text>
                      <v-card-actions
                        class="pa-6 pt-0 mx-auto"
                        style="max-width: 400px"
                      >
                        <v-btn
                          :loading="loading"
                          tabindex="8"
                          block
                          type="submit"
                          class="primary darken-1"
                          @click.prevent="preSubmit"
                          :disabled="
                            disableSubmitButtonByPromotion ||
                            !forms.paguePay ||
                            disableDepositButton ||
                            loading
                          "
                        >
                          {{ $t("btnPix") }}
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paguePay == 2">
                    <v-card-text
                      class="px-6 mx-auto mt-4 mb-6"
                      style="max-width: 400px"
                    >
                      <div class="mt-4">
                        <p class="white--text body-1">
                          {{ $t("paymentText") }}
                        </p>
                        <div class="my-4 white--text body-1">
                          {{ $t("depositValue") }} {{ feedbackDeposit }}
                        </div>
                      </div>
                      <v-btn
                        block
                        @click="$copy(code)"
                        color="primary"
                        class="mb-4"
                      >
                        <v-icon small left>mdi-content-copy</v-icon>
                        {{ $t("pixCopyPaste") }}
                      </v-btn>
                      <div class="d-flex subtitle-1 justify-start align-center">
                        <v-divider class="mr-4"></v-divider>
                        <div>{{ $t("particleOr") }}</div>
                        <v-divider class="ml-4"></v-divider>
                      </div>
                      <div class="mx-auto mt-2" style="width: 250px">
                        <v-img
                          :src="Qrcode"
                          max-height="200px"
                          max-width="200px"
                          class="mx-auto"
                        ></v-img>
                        <v-btn
                          @click="balanceOnline"
                          block
                          class="mt-6"
                          color="green"
                          :disabled="loadingConfirmDeposit"
                        >
                          {{ $t("confirmPayment") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.paguePay == 3">
                    <v-card-text
                      class="px-6 mx-auto mt-10"
                      style="max-width: 600px"
                    >
                      <div class="text-center pa-10">
                        <v-icon color="green" class="mb-6" size="80"
                          >mdi-checkbox-marked-circle-outline</v-icon
                        >
                        <div class="title white--text">
                          {{ $t("depositConfirmed") }}
                        </div>
                        <div class="subtitle-1">
                          {{ $t("congratsDeposit") }}
                        </div>
                        <v-btn
                          @click="steps.paybrokers = 1"
                          class="my-4"
                          color="green"
                        >
                          {{ $t("newDeposit") }}
                        </v-btn>
                        <v-btn
                          v-if="showRedirectToMyPromotionsButton"
                          class="mt-6 px-3"
                          color="primary"
                          :disabled="loadingConfirmDeposit"
                          @click="redirectToMyPromotionsFreespins"
                        >
                          {{ $t("goToMyPromotions") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
              </div>
            </div>

            <!-- PAGFAST METHOD -->
            <div v-else-if="currentPaymentProvider === 'PixPagFast'">
              <div style="width: 100%">
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.pagFast == 1">
                    <v-form
                      ref="form"
                      v-model="forms.pagFast"
                      lazy-validation
                      @submit="preSubmit"
                    >
                      <v-card-text
                        class="px-6 mx-auto"
                        style="max-width: 400px"
                      >
                        <div class="mb-2">
                          <v-text-field
                            id="scrollToPagFastInput"
                            v-model="valueDeposit"
                            type="number"
                            placeholder="00,00"
                            :label="$t('infoValue')"
                            :prefix="$t('labelCurrency')"
                            hide-details="auto"
                            outlined
                            class="grey--text"
                            clearable
                            tabindex="2"
                            @click="scrollToInputValue()"
                            :rules="[minDepositRule]"
                            :autofocus="$vuetify.breakpoint.lgAndUp"
                            onwheel="return false;"
                          ></v-text-field>
                          <div
                            class="d-flex justify-space-between mt-3"
                            v-if="
                              depositBonus.status &&
                              valueDeposit != '' &&
                              !disableDepositButton
                            "
                          >
                            <strong v-if="bonusValue > 0">
                              {{ $t("joinBonus") }}
                              <span style="color: LimeGreen">
                                {{ $t("labelCurrency") }}
                                {{ bonusValue }}
                              </span>
                            </strong>
                            <strong v-else class="text-uppercase">
                              {{ $t("roundsQuantity") }}:
                              <span style="color: LimeGreen">
                                {{ depositQtyFreespins }}
                              </span>
                            </strong>
                          </div>
                        </div>

                        <div v-if="promotions.items.length > 0">
                          <div class="overline pt-4 text-center">
                            {{ $t("promoCodeWithoutOptional") }}
                          </div>
                          <div
                            :class="$vuetify.breakpoint.smAndDown ? '' : 'px-2'"
                          >
                            <PromotionsRadioGroup
                              :promotions="promotions"
                              @showPromotionDetail="showPromotionDetail"
                              @updatePromotionCode="updatePromotionCode"
                              @clearBonusValue="clearBonusValue"
                              :hiddenPromotions="hiddenPromotions"
                              :slideModel="slideModel"
                              ref="promotions"
                            />
                          </div>
                        </div>

                        <div>
                          <span
                            v-html="
                              $t('depositPaymentProviderRules.PixPaguePay')
                            "
                          ></span>
                        </div>
                      </v-card-text>
                      <v-card-actions
                        class="pa-6 pt-0 mx-auto"
                        style="max-width: 400px"
                      >
                        <v-btn
                          :loading="loading"
                          tabindex="8"
                          block
                          type="submit"
                          class="primary darken-1"
                          @click.prevent="preSubmit"
                          :disabled="
                            disableSubmitButtonByPromotion ||
                            !forms.pagFast ||
                            disableDepositButton ||
                            loading
                          "
                        >
                          {{ $t("btnPix") }}
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.pagFast == 2">
                    <v-card-text
                      class="px-6 mx-auto mt-4 mb-6"
                      style="max-width: 400px"
                    >
                      <div class="mt-4">
                        <p class="white--text body-1">
                          {{ $t("paymentText") }}
                        </p>
                        <div class="my-4 white--text body-1">
                          {{ $t("depositValue") }} {{ feedbackDeposit }}
                        </div>
                      </div>
                      <v-btn
                        block
                        @click="$copy(code)"
                        color="primary"
                        class="mb-4"
                      >
                        <v-icon small left>mdi-content-copy</v-icon>
                        {{ $t("pixCopyPaste") }}
                      </v-btn>
                      <div class="d-flex subtitle-1 justify-start align-center">
                        <v-divider class="mr-4"></v-divider>
                        <div>{{ $t("particleOr") }}</div>
                        <v-divider class="ml-4"></v-divider>
                      </div>
                      <div class="mx-auto mt-2" style="width: 250px">
                        <v-img
                          :src="Qrcode"
                          max-height="200px"
                          max-width="200px"
                          class="mx-auto"
                        ></v-img>
                        <v-btn
                          @click="balanceOnline"
                          block
                          class="mt-6"
                          color="green"
                          :disabled="loadingConfirmDeposit"
                        >
                          {{ $t("confirmPayment") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
                <v-scale-transition hide-on-leave>
                  <template v-if="steps.pagFast == 3">
                    <v-card-text
                      class="px-6 mx-auto mt-10"
                      style="max-width: 600px"
                    >
                      <div class="text-center pa-10">
                        <v-icon color="green" class="mb-6" size="80">
                          mdi-checkbox-marked-circle-outline
                        </v-icon>
                        <div class="title white--text">
                          {{ $t("depositConfirmed") }}
                        </div>
                        <div class="subtitle-1">
                          {{ $t("congratsDeposit") }}
                        </div>
                        <v-btn
                          @click="steps.pagFast = 1"
                          class="my-4"
                          color="green"
                        >
                          {{ $t("newDeposit") }}
                        </v-btn>
                        <v-btn
                          v-if="showRedirectToMyPromotionsButton"
                          class="mt-6 px-3"
                          color="primary"
                          :disabled="loadingConfirmDeposit"
                          @click="redirectToMyPromotionsFreespins"
                        >
                          {{ $t("goToMyPromotions") }}
                        </v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-scale-transition>
              </div>
            </div>

            <DepositFooter :currentPaymentProvider="currentPaymentProvider" />
          </div>

          <!-- Skeleton loader divs -->
          <div
            v-else
            style="height: 400px"
            class="d-flex flex-column justify-space-between"
          >
            <div class="d-flex justify-space-around mb-2">
              <v-skeleton-loader
                type="image"
                width="150px"
                height="77px"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                width="150px"
                height="77px"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                width="150px"
                height="77px"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                width="150px"
                height="77px"
              ></v-skeleton-loader>
            </div>
            <div class="align-center">
              <v-skeleton-loader
                type="image"
                style="height: auto; width: auto"
              ></v-skeleton-loader>
            </div>
            <div class="mt-2">
              <v-skeleton-loader
                v-for="n in 3"
                type="text"
                style="width: auto"
                :key="n"
              ></v-skeleton-loader>
            </div>
          </div>
        </div>
      </v-container>
    </v-card>
    <PromotionRules
      v-else
      :rules="currentPromotionDetail.regras"
      @closeRules="showingPromotionDetail = false"
    />
  </v-dialog>
</template>

<script>
import { validate } from "@/util/form-validate";
import theme from "@/plugins/theme";
import ConfirmPromotionChangeDialog from "./ConfirmPromotionChangeDialog.vue";
import DepositFooter from "./DepositFooter.vue";
import PromotionsRadioGroup from "./PromotionsRadioGroup.vue";
import PromotionRules from "./PromotionRules.vue";

export default {
  name: "dialog-deposit-pay4Fun",
  data: () => ({
    slideModel: null,
    depositBonus: {
      status: false,
      bonus_percentage: 0,
      bonus_max: 0,
    },
    depositQtyFreespins: 0,
    valueDeposit: "",
    rules: {
      required: validate.required,
      cvvDigitsCount: validate.cvvDigitsCount,
      wrongValidateCart: validate.wrongValidateCart,
      validateCreditCardNumber: validate.validateCreditCardNumber,
    },
    loading: false,
    Qrcode: "",
    step: 1,

    steps: {
      paybrokers: 1,
      brasilcash: 1,
      lancecerto: 1,
      clinPays: 1,
      paag: 1,
      paguePay: 1,
      pagFast: 1,
    },

    loadingConfirmDeposit: false,

    payment_providers: [],
    recentSuccess: false,
    paymentMethodsFetched: false,

    forms: {
      pay4fun: false,
      paybrokers: false,
      brasilcash: false,
      lancecerto: false,
      clinPays: false,
      paguePay: false,
      pagFast: false,
    },

    fetchingPromotions: false,

    promotions: {
      items: [],
      selected: 0,
      tabSelected: 0,
      promotionBeingChecked: 0,
      checkIntervalId: 0,
    },

    showingPromotionDetail: false,
    currentPromotionDetail: {},

    dialogConfirmPromotionChange: false,
    newPromotion: {},
    oldPromotion: {},
    activePromos: {},
    // o value da clinPay usa a variavel valueDeposit
    registeringNewCard: false,
    registerCard: false,
    hasCard: false,
    safeIdentifier: "",
    cardsList: [],
    SelectedClinPaysCard: "",
    name_player: "",
    number_cart: "",
    validate_cart: "",
    cvv_cart: "",
    code_promo: null,
    saveCard: false,
    showtooltiptext: false,
    gettingListCards: false,
    resolvedListCards: false,
    isValidCard: null,
    // mask: "",
    // brand: "",
    promotionCode: "",
    hiddenPromotions: [],
  }),

  components: {
    ConfirmPromotionChangeDialog,
    DepositFooter,
    PromotionsRadioGroup,
    PromotionRules,
  },

  computed: {
    isXsmall() {
      return this.$vuetify.breakpoint.name == "xs";
    },

    showRedirectToMyPromotionsButton() {
      return (
        this.promotions.tabSelected == 1 && this.$route.name !== "MyPromotions"
      );
    },

    iconSrc() {
      return require(`@/assets/credit-cards-flags/${this.icon}.svg`);
    },

    cvvMask() {
      if (this.icon === "amex") {
        return "####";
      }

      return "###";
    },

    icon() {
      /*
        https://www.w3resource.com/javascript/form/credit-card-validation.php
        American Express :- Starting with 34 or 37, length 15 digits.
        Visa :- Starting with 4, length 13 or 16 digits.
        MasterCard :- Starting with 51 through 55, length 16 digits.
      */
      if (this.number_cart == "") return;
      // this.number_cart.length == 17 pq se não contar com os pontos da v-mask dá errado
      if (this.number_cart.startsWith("3")) {
        return "amex";
      }
      if (this.number_cart.startsWith("4")) {
        return "visa";
      }
      if (
        this.number_cart.startsWith("5") ||
        this.number_cart.startsWith("2")
      ) {
        return "mastercard";
      }
      return false;
    },

    creditCardMask() {
      if (this.number_cart.startsWith("3")) {
        return "#### ###### #####";
      }
      // visa
      if (this.number_cart.startsWith("4")) {
        return "#### #### #### ####";
      }
      // mastercard
      if (
        this.number_cart.startsWith("5") ||
        this.number_cart.startsWith("2")
      ) {
        return "#### #### #### ####";
      }

      return "#### #### #### ####";
    },

    storePromotionCode() {
      return this.$store.state.currentDepositPromotionCode;
    },

    toolbarTitle() {
      const map = {
        PixPaybrokers: this.$t("depositPixByPayBrokers"),
        PixPaybrokersV4: this.$t("depositPixByPayBrokers"),
        PixPay4FunGO: this.$t("depositPixByPay4FunGo"),
        CarteiraPay4FunWallet: this.$t("depositWalletPay4Fun"),
        PixBrasilCash: this.$t("brazilCashDeposit"),
        PixPaag: this.$t("paagDeposit"),
        PixPaguePay: this.$t("paguePayDeposit"),
        PixPagFast: this.$t("pagFastDeposit"),
      };

      return map[this.currentPaymentProvider] || this.$t("deposit");
    },

    isMobile() {
      return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    // Retorna a soma do nome do método com o nome do gateway
    // Ex: PixPaybrokers, PixPay4FunGO, CarteiraPay4FunWallet, PixBrasilCash
    currentPaymentProvider() {
      if (this.payment_providers[this.slideModel]) {
        return this.payment_providers[this.slideModel].uniqueId;
      }

      return "";
    },

    currentCodePromo() {
      if (
        this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
          .withPromotionCode
      ) {
        return this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
          .promotionCode;
      }

      if (this.promotions.items.length > 0) {
        if (this.promoItemsIndexByPromoFilteredIndex !== 0) {
          return this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            .code_promo;
        }
      }

      return "";
    },

    disableSubmitButtonByPromotion() {
      if (this.promotionCode) {
        return false;
      }

      if (this.promotions.items.length > 0) {
        if (this.promoItemsIndexByPromoFilteredIndex !== 0) {
          if (this.promotions.promotionBeingChecked > 0) {
            return true;
          }

          if (
            this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
              .message.type !== "success"
          ) {
            return true;
          }
        }
      }

      return false;
    },

    minPay4FunDeposit() {
      if (this.$store.state.operators.deposit_min > 20) {
        return this.$store.state.operators.deposit_min;
      }

      return 20;
    },

    dialogDeposit() {
      return this.$store.state.dialogDeposit;
    },

    bonusValue() {
      const earnBonus =
        this.valueDeposit * (this.depositBonus.bonus_percentage / 100);

      if (earnBonus > this.depositBonus.bonus_max) {
        return this.depositBonus.bonus_max;
      }

      return earnBonus.toFixed(2);
    },

    minDepositRule() {
      const minDeposit = parseFloat(this.$store.state.operators.deposit_min);

      if (minDeposit <= parseFloat(this.valueDeposit)) {
        return true;
      }

      return this.$t("minimumDepositAmount", { value: minDeposit.toFixed(2) });
    },

    minDepositPay4FunRule() {
      if (
        this.minPay4FunDeposit > parseFloat(this.valueDeposit) ||
        !this.valueDeposit
      ) {
        return this.$t("minimumDepositAmount", {
          value: this.minPay4FunDeposit.toFixed(2),
        });
      }

      return true;
    },

    maxDepositPay4FunRule() {
      const maxPay4FunDeposit = 30000;

      if (maxPay4FunDeposit < parseFloat(this.valueDeposit)) {
        return this.$t("maximumDepositAmount", {
          value: maxPay4FunDeposit.toFixed(2),
        });
      }

      return true;
    },

    disableDepositButton() {
      if (this.promotions.promotionBeingChecked > 0) {
        return true;
      }

      if (
        !this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
          .noPromotionOption &&
        this.promotions.items[this.promoItemsIndexByPromoFilteredIndex].message
          .type !== "success"
      ) {
        return true;
      }

      let minDeposit = parseFloat(this.$store.state.operators.deposit_min);

      if (minDeposit <= parseFloat(this.valueDeposit)) {
        return false;
      }

      return true;
    },

    disablePay4FunDepositButton() {
      if (!this.valueDeposit) {
        return true;
      }

      let minPay4FunDeposit = Number("20.00");
      const maxPay4FunDeposit = parseFloat("30000").toFixed(2);

      if (
        parseFloat(this.valueDeposit) < minPay4FunDeposit ||
        this.valueDeposit == ""
      ) {
        return true;
      }
      if (parseFloat(this.valueDeposit) > maxPay4FunDeposit) {
        return true;
      }
      return false;
    },

    getMerchantLogo() {
      return this.$operatorLogoUrl(this.$domain());
    },

    promoItemsIndexByPromoFilteredIndex() {
      // Filtrando as promoções/campanha de acordo com a tab selecionada
      const promotionsFilteredByTab = this.promotions.items.filter((promo) => {
        if (promo.noPromotionOption || promo.withPromotionCode) {
          return promo;
        } else if (
          this.promotions.tabSelected == 1 &&
          promo.product_type == "casino"
        ) {
          return promo;
        } else if (
          this.promotions.tabSelected == 0 &&
          promo.product_type != "casino"
        ) {
          return promo;
        }
      });

      const promoFilteredItemsIndex = this.promotions.selected;
      let indexPromoSelected = 0;

      // Buscando index em promotions.items a partir do index recebido do radio
      // button selecionado
      if (promotionsFilteredByTab[promoFilteredItemsIndex].code_promo) {
        indexPromoSelected = this.promotions.items.findIndex(
          (promo) =>
            promo.code_promo &&
            promo.code_promo ===
              promotionsFilteredByTab[promoFilteredItemsIndex].code_promo
        );
      } else if (promotionsFilteredByTab[promoFilteredItemsIndex].codigo) {
        indexPromoSelected = this.promotions.items.findIndex(
          (promo) =>
            promo.codigo &&
            promo.codigo ===
              promotionsFilteredByTab[promoFilteredItemsIndex].codigo
        );
      } else if (
        promotionsFilteredByTab[promoFilteredItemsIndex].noPromotionOption
      ) {
        indexPromoSelected = 0;
      } else if (
        promotionsFilteredByTab[promoFilteredItemsIndex].withPromotionCode
      ) {
        indexPromoSelected = this.promotions.items.length - 1;
      }

      return indexPromoSelected;
    },
  },

  async mounted() {
    if (!this.$store.state.logged.status) {
      this.closeDialog();
      return;
    }

    this.code = "";
    this.Qrcode = "";
    document.removeEventListener("visibilitychange", this.listener, false);
    this.$nextTick(async () => {
      if (this.dialogDeposit) {
        this.updatePaymentMethods();
        await this.fetchDepositUserPromotions();
        await this.fetchUserActivePromotion();
        this.dialogConfirmPromotionChange = false;
      }
    });
  },

  watch: {
    promotionCode(val) {
      if (val) {
        this.updatePromotionCode(val);
      } else {
        if (
          this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            .withPromotionCode
        ) {
          this.promotions.items[
            this.promoItemsIndexByPromoFilteredIndex
          ].message = {
            type: "",
            message: "",
            loading: false,
          };
        }
      }
    },
    "promotions.selected"() {
      const promoItemsIndex = this.promoItemsIndexByPromoFilteredIndex;
      if (
        this.promotions.items[promoItemsIndex] &&
        this.promotions.items[promoItemsIndex].withPromotionCode
      ) {
        this.$refs.promotions && this.$refs.promotions.focusOnPromotionCode();

        if (!this.promotionCode) {
          this.promotionCode = "";
          this.clearPromotionCode();
          return;
        }
      } else {
        this.promotionCode = "";
        this.$refs.promotions.clearPromotionCode();
      }

      this.depositBonus.status = false;
      this.depositBonus.bonus_percentage = 0;
      this.depositBonus.bonus_max = 0;
      this.depositQtyFreespins = 0;
      this.promotions.items[promoItemsIndex].message.type = "";
      this.promotions.items[promoItemsIndex].message.text = "";

      const somePromotionSelected =
        this.promotions.items.length > 0 &&
        !this.promotions.items[promoItemsIndex].noPromotionOption;

      if (somePromotionSelected) {
        this.debouncedUserHasPromotion(this.promotions.items[promoItemsIndex]);
      } else {
        this.resetPromoCode();
      }
    },

    valueDeposit(val) {
      let somePromotionSelected = false;

      if (
        val &&
        this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
          .withPromotionCode
      ) {
        this.debouncedUserHasPromotion(
          {},
          this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            .promotionCode
        );
      } else if (this.promotions.items.length > 0) {
        somePromotionSelected =
          this.promotions.items.length > 0 &&
          !this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            .noPromotionOption;

        if (
          this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            .withPromotionCode
        ) {
          if (!this.promotionCode) {
            return;
          }
        }

        if (val && somePromotionSelected) {
          this.debouncedUserHasPromotion(
            this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
          );
        }
      }

      if (!val) {
        // usuário tirou o valor, vamos resetar a mensagem da promoção
        if (somePromotionSelected) {
          this.promotions.items[
            this.promoItemsIndexByPromoFilteredIndex
          ].message = {
            type: "",
            message: "",
            loading: false,
          };
        }
      }
      if (!somePromotionSelected) {
        this.promotions.promotionBeingChecked = 0;
      }
    },

    slideModel() {
      this.promotions.tabSelected = 0;
      this.promotions.selected = 0;
      this.promotions.code_promo = "";
      this.clearPromotionCode();
      if (this.promotions.items.length > 0) {
        if (
          this.promoItemsIndexByPromoFilteredIndex !==
          this.promotions.items.length - 1
        ) {
          this.debouncedUserHasPromotion(
            this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
          );
        }
      }

      this.$nextTick(() => {
        if (this.valueDeposit) {
          if (this.$refs.form) {
            const func = this.currentPaymentProvider.includes("PaguePay")
              ? "resetValidation"
              : "validate";
            this.$refs.form[func]();
          }
        }
      });
    },

    async dialogDeposit(val) {
      if (val) {
        if (!this.$store.state.logged.status) {
          this.closeDialog();
          return;
        }

        this.promotions.tabSelected = 0;
        this.promotions.selected = 0;
        this.promotions.code_promo = "";
        this.clearPromotionCode();

        this.dialogConfirmPromotionChange = false;

        this.updatePaymentMethods();
        await this.fetchDepositUserPromotions();
        await this.fetchUserActivePromotion();

        if (this.valueDeposit != null && this.valueDeposit != "") {
          if (
            this.promotions.items.length > 0 &&
            this.promoItemsIndexByPromoFilteredIndex !==
              this.promotions.items.length - 1
          ) {
            this.debouncedUserHasPromotion(
              this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            );
          }
        }

        this.recentSuccess = false;

        if (this.payment_providers.length == 0) {
          return;
        }

        this.slideModel = 0;
      }
      if (!val) {
        this.resetPromoCode();
        this.depositBonus.status = false;
        this.promotionCode = "";
      }
    },

    currentPaymentProvider(val) {
      this.promotions.tabSelected = 0;
      this.promotions.selected = 0;
      this.promotions.code_promo = "";
      this.clearPromotionCode();
      if (val === "CartãoClinPays" && !this.resolvedListCards) {
        this.listClinPaysCards();
      }
    },
  },

  methods: {
    clearBonusValue() {
      this.depositBonus.status = false;
      this.depositBonus.bonus_percentage = 0;
      this.depositBonus.bonus_max = 0;
      this.depositQtyFreespins = 0;
    },

    clearPromotionCode() {
      this.promotionCode = "";
    },

    updatePromotionCode(val) {
      this.promotionCode = val;

      if (val) {
        this.promotions.items[
          this.promoItemsIndexByPromoFilteredIndex
        ].message = {
          type: "",
          message: "",
          loading: false,
        };

        // this.promotions.selected = 0;

        this.debouncedUserHasPromotion({}, val);
        this.promotionCode = "";
      } else {
        this.depositBonus.status = false;
        this.depositBonus.bonus_percentage = 0;
        this.depositBonus.bonus_max = 0;
        this.depositQtyFreespins = 0;
        this.promotionCode = "";

        this.promotions.items[
          this.promoItemsIndexByPromoFilteredIndex
        ].message.loading = false;
      }
    },

    updatePaymentMethods() {
      // Vamos atualizar os métodos de pagamento
      this.paymentMethodsFetched = false;

      this.$axios
        .get("/player/online/bank/listPaymentMethods")
        .then((res) => {
          this.payment_providers = res.data.dados
            .filter(
              (method) =>
                method.fluxo === "1" &&
                method.method_status === "1" &&
                method.nome_metodo !== "Boleto"
            )
            .map((m) => ({ ...m, uniqueId: m.nome_metodo + m.nome_gateway }));

          // Pushando obj mock para PaguePay
          // this.payment_providers.push(
          //   {
          //     fluxo: "1",
          //     id: "19",
          //     id_banca: "659",
          //     id_gateway: "9",
          //     id_metodo: "1",
          //     method_status: "1",
          //     nome_gateway: "PaguePay",
          //     nome_metodo: "Pix",
          //     // uniqueId: "PixPaguePay",
          //   }
          // );
          // console.log('depois', this.payment_providers);
        })
        .catch(() => {})
        .finally(() => {
          this.paymentMethodsFetched = true;
        });
    },

    closeDialog() {
      this.$store.commit("dialogDeposit", false);

      this.steps.paybrokers = 1;
      this.steps.brasilcash = 1;
      this.steps.lancecerto = 1;
      this.steps.clinPays = 1;
      this.steps.paag = 1;
      this.steps.paguePay = 1;
      this.steps.pagFast = 1;
      this.code = "";
      this.Qrcode = "";

      if (!this.recentSuccess) {
        this.balanceOnline();
      }
      // Remove Listener
      document.removeEventListener("visibilitychange", this.listener, false);
    },

    preSubmit() {
      const currentPromo =
        this.promotions.items[this.promoItemsIndexByPromoFilteredIndex];

      const somePromotionSelected =
        this.promotions.items.length > 0 && !currentPromo.noPromotionOption;

      if (this.activePromos !== false && somePromotionSelected) {
        if (this.promotions.tabSelected == 0) {
          this.oldPromotion = Object.values(this.activePromos)[1];
        } else {
          this.oldPromotion = Object.values(this.activePromos)[0];
        }

        const isActive =
          this.oldPromotion &&
          Object.values(this.oldPromotion).find((item) => item != null);
        if (isActive) {
          if (currentPromo.withPromotionCode) {
            const newPromotion = {
              type_promo: "withPromotionCode",
              promo_code: currentPromo.promotionCode,
            };
            const promotionListed = this.promotions.items.find(
              (promotion) =>
                promotion.code_promo &&
                promotion.code_promo.toUpperCase() ===
                  currentPromo.promotionCode.toUpperCase()
            );

            if (promotionListed) {
              newPromotion.promo_title = promotionListed.titulo;
            }

            this.newPromotion = newPromotion;
          } else {
            this.newPromotion = {
              type_promo: currentPromo.type_promo,
              promo_title: currentPromo.titulo,
              promo_code: currentPromo.code_promo,
            };
          }

          this.dialogConfirmPromotionChange = true;
          return;
        }
      }
      this.submitDeposit();
    },

    async paybrokersDeposit() {
      // Recuperando PIX COPIA/COLA E QRCODE;
      this.loading = true;

      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        is_deposit_bonus: this.depositBonus.status ? "1" : "0",
        code_promo: this.currentCodePromo,
      };

      let endpoint = "/player/online/bank/depositOnline";

      if (this.currentPaymentProvider === "PixPaybrokersV4") {
        endpoint = "/player/payments/paybrokers/depositOnline";
      }

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((resp) => {
          this.Qrcode = resp.data.link_billet;
          this.code = resp.data.code;
          this.feedbackDeposit = body.value;
          this.steps.paybrokers = 2;
        })
        .then(() => {
          // Ouvindo o pagamento
          this.listenerDeposit();
          // Register Event generate_pix Analytics;
          this.$gtag.generate_pix(body.value, this.depositBonus.status);
        })
        .then(() => {
          this.valueDeposit = "";
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.closeDialog();
            this.$router.push({ name: "Perfil" });
          } else {
            const msg = err.response.data.messages.error;
            const color = "warning";
            this.$store.commit("setNotification", { msg, color });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async payForFunDeposit() {
      this.loading = true;

      try {
        const amount = this.valueDeposit
          ? parseFloat(this.valueDeposit).toFixed(2)
          : 0;

        const id_metodo =
          this.currentPaymentProvider == "CarteiraPay4FunWallet" ? "2" : "1";

        const paymentMethodId =
          this.currentPaymentProvider == "PixPay4FunGO" ? "98" : "1";

        const is_deposit_bonus = this.depositBonus.status ? "1" : "0";

        const body = {
          is_deposit_bonus,
          amount,
          id_metodo,
          paymentMethodId,
          merchantLogo: this.getMerchantLogo,
          layoutColor: theme.colorAppBar,
          code_promo: this.currentCodePromo,
        };

        const response = await this.$axios.post(
          "/player/online/bank/depositOnlinePayForFun",
          this.$formdata(body)
        );
        const redirectToURL = Object.values(response.data.dados).toString();
        this.recentSuccess = true;
        window.open(redirectToURL);
      } catch (error) {
        const msg = error.response.data.messages.error;
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      } finally {
        this.loading = false;
        this.valueDeposit = "";
        this.closeDialog();
      }
    },

    async brasilCashDeposit() {
      this.loading = true;

      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        code_promo: this.currentCodePromo,
      };

      this.$axios
        .post(
          "/player/online/bank/depositOnlineBrasilCash",
          this.$formdata(body)
        )
        .then((res) => {
          this.Qrcode = res.data.link_billet;
          this.code = res.data.code;
          this.feedbackDeposit = body.value;
          this.steps.brasilcash = 2;
        })
        .then(() => {
          this.listenerDeposit();
          this.$gtag.generate_pix(body.value, this.depositBonus.status);
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async lancecertoDeposit() {
      // Recuperando PIX COPIA/COLA E QRCODE;
      this.loading = true;

      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        code_promo: this.currentCodePromo,
      };

      this.$axios
        .post("/player/payments/lanceCerto/depositLC", this.$formdata(body))
        .then((resp) => {
          this.Qrcode = resp.data.link_billet;
          this.code = resp.data.code;
          this.feedbackDeposit = body.value;
          this.steps.lancecerto = 2;
        })
        .then(() => {
          // Ouvindo o pagamento
          this.listenerDeposit();
          // Register Event generate_pix Analytics;
          this.$gtag.generate_pix(body.value, this.depositBonus.status);
        })
        .then(() => {
          this.valueDeposit = "";
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.closeDialog();
            this.$router.push({ name: "Perfil" });
          } else {
            const msg = err.response.data.messages.error;
            const color = "warning";
            this.$store.commit("setNotification", { msg, color });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async submitDeposit() {
      if (
        this.currentPaymentProvider == "PixPaybrokers" ||
        this.currentPaymentProvider == "PixPaybrokersV4"
      ) {
        this.paybrokersDeposit();
      } else if (
        this.currentPaymentProvider === "PixPay4FunGO" ||
        this.currentPaymentProvider === "CarteiraPay4FunWallet"
      ) {
        this.payForFunDeposit();
      } else if (this.currentPaymentProvider === "PixBrasilCash") {
        this.brasilCashDeposit();
      } else if (this.currentPaymentProvider === "PixLanceCerto") {
        this.lancecertoDeposit();
      } else if (this.currentPaymentProvider === "CartãoClinPays") {
        this.clinPaysDeposit();
      } else if (this.currentPaymentProvider === "PixPaag") {
        this.paagDeposit();
      } else if (this.currentPaymentProvider === "PixPaguePay") {
        this.paguePayDeposit();
      } else if (this.currentPaymentProvider === "PixPagFast") {
        this.pagFastDeposit();
      }
    },

    async paagDeposit() {
      this.loading = true;
      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        code_promo: this.currentCodePromo,
      };
      this.$axios
        .post("/player/payments/paag/depositOnlinePaag", this.$formdata(body))
        .then((resp) => {
          this.Qrcode = resp.data.link_billet;
          this.code = resp.data.code;
          this.feedbackDeposit = body.value;
          this.steps.paag = 2;
        })
        .then(() => {
          // Ouvindo o pagamento
          this.listenerDeposit();
          // Register Event generate_pix Analytics;
          this.$gtag.generate_pix(body.value, this.depositBonus.status);
        })
        .then(() => {
          this.valueDeposit = "";
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.closeDialog();
            this.$router.push({ name: "Perfil" });
          } else {
            const msg = err.response.data.messages.error;
            const color = "warning";
            this.$store.commit("setNotification", { msg, color });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async clinPaysDeposit() {
      // 1 - deposito registrando o cartao
      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        code_promo: this.currentCodePromo,
        date_validate: this.validate_cart,
        number_cart: this.number_cart.replaceAll(".", ""),
        code_security: this.cvv_cart,
        saveCard: this.saveCard ? "1" : "0",
        // id_cart: "",
      };
      if (this.registerCard) {
        this.loading = true;
        this.$axios
          .post(
            "/player/payments/clinPays/depositClinPays",
            this.$formdata(body)
          )
          .then(() => {
            this.steps.clinPays = 2;
            const hasBt = this.$permissions().bigTable;
            const suffix = hasBt ? "Bt" : "Sports";
            this.$router.push({ name: `DepositSuccess${suffix}` });
          })
          .catch((err) => {
            this.$store.commit("setNotification", {
              msg: err.response.data.messages.error,
              color: "warning",
            });
          })
          .finally(() => {
            if (this.saveCard) {
              this.listClinPaysCards();
            }
            this.saveCard = false;
            this.loading = false;
          });
      }
      if (this.hasCard) {
        this.loading = true;
        (body.id_cart = this.SelectedClinPaysCard._id),
          this.$axios
            .post(
              "/player/payments/clinPays/depositClinPays",
              this.$formdata(body)
            )
            .then(() => {
              this.steps.clinPays = 2;
              const hasBt = this.$permissions().bigTable;
              const suffix = hasBt ? "Bt" : "Sports";
              this.$router.push({ name: `DepositSuccess${suffix}` });
            })
            .catch((err) => {
              this.$store.commit("setNotification", {
                msg: err.response.data.messages.error,
                color: "warning",
              });
            })
            .finally(() => {
              if (this.saveCard) {
                this.listClinPaysCards();
              }
              this.saveCard = false;
              this.loading = false;
            });
      }
    },

    async listClinPaysCards() {
      /*
        A lógica é feita baseada nos status:
        400 - não tem cartão
        200 - tem o cliente e tem o cartão (tem 1 cenário que pode ser q n tenha cartão)
      */
      this.gettingListCards = true;

      await this.$axios
        .get("/player/payments/clinPays/getInfoClient")
        .then((resp) => {
          if (resp.data.dados.length == 0) {
            /*
            cenário onde existe o cliente, mas n tem cartao
            Ex.: cadastrou o 1º cartao errado, pediu pro suporte remover
            para cadastrar um novo
          */
            this.gettingListCards = false;
            this.resolvedListCards = true;
            this.registerCard = true;
            this.hasCard = false;
            return;
          }

          this.cardsList = resp.data.dados;

          this.gettingListCards = false;
          this.resolvedListCards = true;
          this.hasCard = true;
          this.registerCard = false;
        })
        .catch(() => {
          this.gettingListCards = false;
          this.resolvedListCards = true;
          this.registerCard = true;
          this.hasCard = false;
        });
    },

    async paguePayDeposit() {
      this.loading = true;

      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        is_deposit_bonus: this.depositBonus.status ? "1" : "0",
        code_promo: this.currentCodePromo,
      };

      const endpoint = "/player/payments/paguePay/depositOnline";

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((resp) => {
          this.Qrcode = resp.data.link_billet;
          this.code = resp.data.code;
          this.feedbackDeposit = body.value;
          this.steps.paguePay = 2;
        })
        .then(() => {
          // Ouvindo o pagamento
          this.listenerDeposit();
          // Register Event generate_pix Analytics;
          this.$gtag.generate_pix(body.value, this.depositBonus.status);
        })
        .then(() => {
          this.valueDeposit = "";
        })
        .then(() => {
          if (this.$domain() === "betdasorte") {
            try {
              _mgq.push(["MgSensorInvoke", "deposito557"]);
            } catch (e) {
              console.log("Erro mgid push", e);
            }
          }
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.closeDialog();
            this.$router.push({ name: "Perfil" });
          } else {
            const msg = err.response.data.messages.error;
            const color = "warning";
            this.$store.commit("setNotification", { msg, color });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async pagFastDeposit() {
      this.loading = true;
      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        is_deposit_bonus: this.depositBonus.status ? "1" : "0",
        code_promo: this.currentCodePromo,
      };
      const endpoint = "/player/payments/pagFast/depositOnline";
      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((resp) => {
          this.Qrcode = resp.data.link_billet;
          this.code = resp.data.code;
          this.feedbackDeposit = body.value;
          this.steps.pagFast = 2;
        })
        .then(() => {
          // Ouvindo o pagamento
          this.listenerDeposit();
          // Register Event generate_pix Analytics;
          this.$gtag.generate_pix(body.value, this.depositBonus.status);
        })
        .then(() => {
          this.valueDeposit = "";
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.closeDialog();
            this.$router.push({ name: "Perfil" });
          } else {
            const msg = err.response.data.messages.error;
            const color = "warning";
            this.$store.commit("setNotification", { msg, color });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    balanceOnline() {
      if (!this.$store.state.logged.status) {
        return;
      }

      this.loadingConfirmDeposit = true;

      this.$axios
        .get("/player/online/bank/balanceOnline")
        .then(async (resp) => {
          const cash = Number(this.$store.state.cash);
          const cashResp = Number(resp.data.dados.balance);

          if (
            cashResp > cash &&
            (this.currentPaymentProvider === "PixPaybrokers" ||
              this.currentPaymentProvider === "PixPaybrokersV4" ||
              this.currentPaymentProvider === "PixBrasilCash" ||
              this.currentPaymentProvider === "PixLanceCerto" ||
              this.currentPaymentProvider === "PixPaag" ||
              this.currentPaymentProvider === "PixPaguePay" ||
              this.currentPaymentProvider === "PixPagFast")
          ) {
            await this.fetchDepositUserPromotions();
            await this.fetchUserActivePromotion();

            if (
              this.currentPaymentProvider === "PixPaybrokers" ||
              this.currentPaymentProvider === "PixPaybrokersV4"
            ) {
              this.steps.paybrokers = 3;
            } else if (this.currentPaymentProvider === "PixBrasilCash") {
              this.steps.brasilcash = 3;
            } else if (this.currentPaymentProvider === "PixLanceCerto") {
              this.steps.lancecerto = 3;
            } else if (this.currentPaymentProvider === "PixPaag") {
              this.steps.paag = 3;
            } else if (this.currentPaymentProvider === "PixPaguePay") {
              this.steps.paguePay = 3;
            } else if (this.currentPaymentProvider === "PixPagFast") {
              this.steps.pagFast = 3;
            }

            // this.title = "Obrigado!";

            // Register LocalStorage;
            this.$axios
              .post("/player/user/qtyPlayerDeposits")
              .then((response) => {
                var qtyPlayerDeposits = response.data.dados.qty_deposits;
                if (qtyPlayerDeposits === "1") {
                  // Registrando o Primeiro Deposito
                  this.$gtag.first_deposit(
                    this.feedbackDeposit,
                    this.depositBonus.status
                  );

                  // Register Event Deposito in Integrations;
                  this.$activeCampaign("firstDeposit");
                  this.$zendesk("firstDeposit");
                  this.$rdStation("firstDeposit");
                }
              });

            // Enviando para LGaming todos os depósitos:
            this.$lgaming("deposit");

            // Register Event GA4;
            this.$gtag.consolidated_pix(
              this.feedbackDeposit,
              this.depositBonus.status
            );

            document.removeEventListener(
              "visibilitychange",
              this.listener,
              false
            );

            const hasBt = this.$permissions().bigTable;
            const suffix = hasBt ? "Bt" : "Sports";
            this.$router.push({ name: `DepositSuccess${suffix}` });
          }

          // Update Saldo;
          this.$store.commit("setCash", resp.data.dados.balance);
          this.$store.commit("setBonus", {
            value: resp.data.dados.balance_bonus,
            status: resp.data.dados.balance_bonus_status,
          });
          this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
          this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
        })
        .catch(() => {})
        .finally(() => {
          this.loadingConfirmDeposit = false;
        });
    },

    // Observando Pagamento
    listenerDeposit() {
      document.addEventListener("visibilitychange", this.listener, false);
    },

    listener() {
      this.balanceOnline();
    },

    scrollToInputValue() {
      if (!this.$vuetify.breakpoint.xs) {
        return;
      }

      const map = {
        PixPaybrokers: "scrollToPaybrokersValue",
        PixPaybrokersV4: "scrollToPaybrokersValue",
        CarteiraPay4FunWallet: "scrollToPay4FunInput",
        PixPay4FunGO: "scrollToPay4FunInput",
        PixBrasilCash: "scrollToBrasilCashInput",
        CartãoClinPays: "scrollToClinPaysInput",
        PixLanceCerto: "scrollToLanceCertoValue",
        PixPaag: "scrollToPaagValue",
        PixPaguePay: "scrollToPaguePayInput",
        PixPagFast: "scrollToPagFastInput",
      };

      if (this.registeringNewCard) {
        map.CartãoClinPays = "scrollToNumberCart";
      }

      const inputId = map[this.currentPaymentProvider];

      if (document.getElementById(inputId)) {
        document.getElementById(inputId).scrollIntoView({ behavior: "smooth" });
      }
    },

    debouncedUserHasPromotion(promotion, promotionCode = false) {
      if (this.valueDeposit == null || this.valueDeposit == "") {
        return;
      }

      if (promotionCode === false) {
        clearInterval(this.promotions.checkIntervalId);

        if (
          this.promotions.items.length === 0 ||
          this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
            .noPromotionOption
        ) {
          return;
        }

        this.promotions.promotionBeingChecked = promotion.id;
        this.promotions.items[
          this.promoItemsIndexByPromoFilteredIndex
        ].message.type = "";
        this.promotions.items[
          this.promoItemsIndexByPromoFilteredIndex
        ].message.text = "";

        this.depositBonus.status = false;
        this.depositBonus.bonus_percentage = 0;
        this.depositBonus.bonus_max = 0;
        this.depositQtyFreespins = 0;

        this.promotions.checkIntervalId = setTimeout(() => {
          this.userHasPromotion(promotion);
        }, 1000);
      } else {
        clearInterval(this.promotionCodeInterval);

        this.promotions.items[
          this.promoItemsIndexByPromoFilteredIndex
        ].message.loading = true;

        this.depositBonus.status = false;
        this.depositBonus.bonus_percentage = 0;
        this.depositBonus.bonus_max = 0;
        this.depositQtyFreespins = 0;

        this.promotionCodeInterval = setTimeout(() => {
          this.userHasPromotion({ code_promo: promotionCode }, true);
        }, 1000);
      }
    },

    userHasPromotion(promotion, promotionCode = false) {
      this.$axios
        .post(
          "/player/bonus/promotion/userPromoActive",
          this.$formdata({
            code_promo: promotion.code_promo,
            value: this.valueDeposit,
            product_type:
              this.promotions.tabSelected == 0 ? "sportbook" : "casino",
          })
        )
        .then((res) => {
          if (promotionCode === false) {
            this.promotions.items = this.promotions.items.map((p) => {
              if (p.id === promotion.id) {
                return {
                  ...p,
                  message: {
                    type: "success",
                    text: res.data.messages,
                  },
                };
              }

              return {
                ...p,
                message: { type: "", text: "" },
              };
            });

            if (
              this.promotions.items[this.promoItemsIndexByPromoFilteredIndex]
                .id === promotion.id
            ) {
              this.depositBonus.status = true;
              this.depositBonus.bonus_percentage =
                res.data.dados.bonus_percentage;
              this.depositBonus.bonus_max = res.data.dados.bonus_max;
              this.depositQtyFreespins = res.data.dados.casino_freespins_qty;
            } else {
              this.promotions.items.forEach((p) => {
                if (p.id === promotion.id) {
                  p.message.type = "";
                  p.message.text = "";
                }
              });
            }
          } else {
            // this.promoCodeFeedback = {
            //   successMessage: res.data.messages,
            //   errorMessage: "",
            //   success: true,
            //   error: false,
            // };

            this.promotions.items[
              this.promoItemsIndexByPromoFilteredIndex
            ].message = {
              type: "success",
              text: res.data.messages,
              loading: false,
            };

            this.depositBonus.status = true;
            this.depositBonus.bonus_percentage =
              res.data.dados.bonus_percentage;
            this.depositBonus.bonus_max = res.data.dados.bonus_max;
            this.depositQtyFreespins = res.data.dados.casino_freespins_qty;
          }
        })
        .catch((err) => {
          if (promotionCode === false) {
            this.promotions.items = this.promotions.items.map((p) => {
              if (p.id === promotion.id) {
                return {
                  ...p,
                  message: {
                    type: "error",
                    text: err.response.data.messages.error,
                  },
                };
              }

              return {
                ...p,
                message: { type: "", text: "" },
              };
            });

            this.depositBonus.status = false;
            this.depositBonus.bonus_percentage = 0;
            this.depositBonus.bonus_max = 0;
            this.depositQtyFreespins = 0;
          } else {
            this.promotions.items[
              this.promoItemsIndexByPromoFilteredIndex
            ].message = {
              type: "error",
              text: err.response.data.messages.error,
              loading: false,
            };

            this.$refs.promotions &&
              this.$refs.promotions.focusOnPromotionCode();

            this.depositBonus.status = false;
            this.depositBonus.bonus_percentage = 0;
            this.depositBonus.bonus_max = 0;
            this.depositQtyFreespins = 0;
          }
        })
        .finally(() => {
          this.promotions.promotionBeingChecked = 0;
          this.promotions.items[
            this.promoItemsIndexByPromoFilteredIndex
          ].message.loading = false;
        });
    },

    resetPromoCode() {
      this.promotions.items = this.promotions.items.map((p) => ({
        ...p,
        message: { type: "", text: "" },
      }));

      this.promotions.promotionBeingChecked = 0;

      // Bônus
      this.depositBonus.status = false;
      this.depositBonus.bonus_percentage = 0;
      this.depositBonus.bonus_max = 0;
      this.depositQtyFreespins = 0;
    },

    async fetchDepositUserPromotions() {
      this.fetchingPromotions = true;

      this.$axios
        .get("/player/bonus/promotion/listAvaliable")
        .then((res) => {
          const shown = [];
          const hidden = [];

          res.data.dados.forEach((promotion) => {
            if (promotion.hide === "1") {
              hidden.push(promotion);
            } else {
              shown.push(promotion);
            }
          });

          this.hiddenPromotions = hidden;

          this.promotions.items = shown.map((promotion) => ({
            ...promotion,
            message: { type: "", message: "" },
          }));

          const noPromotionOption = {
            noPromotionOption: true,
            type_promo: this.$t("none"),
            message: { type: "", message: "" },
          };

          const withPromotionCode = {
            withPromotionCode: true,
            message: { type: "", message: "", loading: false },
          };

          this.promotions.items = [
            noPromotionOption,
            ...this.promotions.items,
            withPromotionCode,
          ];

          if (this.storePromotionCode) {
            this.selectPromotionByCode(this.storePromotionCode);
            this.$store.commit("resetCurrentDepositPromotionCode");
          }
        })
        .catch(() => {
          const noPromotionOption = {
            noPromotionOption: true,
            type_promo: this.$t("none"),
            message: { type: "", message: "" },
          };

          const withPromotionCode = {
            withPromotionCode: true,
            message: { type: "", message: "", loading: false },
          };

          this.promotions.items = [noPromotionOption, withPromotionCode];
        })
        .finally(() => {
          this.fetchingPromotions = false;
        });
    },

    async fetchUserActivePromotion() {
      this.$axios
        .get("/player/bonus/promotion/listActivePromotions")
        // O novo endpoint sempre vai retornar algo no promo_code e promo_title
        // caso haja uma promo ativa. Caso não, esses campos vem com valor 'null'
        // .get("/player/bonus/promotion/listActives")
        .then((res) => {
          this.activePromos = res.data.dados;
        })
        .catch(() => {
          this.activePromos = {};
        });
    },

    showPromotionDetail(promotion) {
      this.showingPromotionDetail = true;
      this.currentPromotionDetail = promotion;
    },

    transformTypePromo(type_promo) {
      const map = {
        "1ºdeposito": this.$t("firstDepositPromotion"),
        deposito: this.$t("depositPromotion"),
      };

      return map[type_promo] || null;
    },

    getMethodImage(methodUniqueId) {
      const map = {
        PixPaybrokers: "paybrokers-logo",
        PixPaybrokersV4: "paybrokers-logo",
        PixPay4FunGO: "pay4fungo_pix",
        CarteiraPay4FunWallet: "Pay4Funlogo",
        PixBrasilCash: "brasilCash",
        PixLanceCerto: "lancecertopix",
        CartãoClinPays: "logoClinPays",
        PixPaag: "paag",
        PixPaguePay: "paguePay",
        PixPagFast: "pagFast",
      };
      // retrieving paguePay logo hardCoded
      // if (methodUniqueId == 'PixPaguePay') {
      //   return require("@/assets/PaguePay_Logo_250x130.png")
      // }

      return this.$paymentMethodLogoUrl(methodUniqueId, map[methodUniqueId]);
    },

    selectPromotionByCode(code) {
      localStorage.setItem(
        "depositPromotionCodeFromPromotions",
        JSON.stringify(code)
      );
    },

    tooltipText() {
      this.showtooltiptext = !this.showtooltiptext;
    },

    useAnotherCard() {
      this.registerCard = true;
      this.registeringNewCard = true;
      this.hasCard = false;
      this.valueDeposit = "";
      this.number_cart = "";
      this.validate_cart = "";
      this.cvv_cart = "";
      this.scrollToInputValue();
    },

    previous() {
      this.listClinPaysCards();
    },

    async newDepositClinPays() {
      await this.fetchUserActivePromotion();
      this.steps.clinPays = 1;
    },

    onKeyUp() {
      this.promotionCode = this.promotionCode
        .toUpperCase()
        // Tira espaço em branco
        .replace(/\s/g, "");
    },

    redirectToMyPromotionsFreespins() {
      this.$router.push({
        name: "MyPromotions",
        query: {
          fromDialogDeposit: "tabCasino",
        },
      });

      return this.closeDialog();
    },
  },
};
</script>

<style scoped>
.v-dialog__content.v-dialog__content--active {
  z-index: 701 !important;
}
.v-tooltip__content {
  text-align: justify;
  width: 200px !important;
}
/* Classes tooltip mobile inicio */
.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.tooltip .tooltiptext {
  background-color: #757575;
  opacity: 0.9;
  position: absolute;
  width: 256px;
  text-align: justify;
  padding: 8px 12px;
  border-radius: 6px;
  bottom: 10px;
  z-index: 1;
  transition: all 0, 3s;
}
.iconColor {
  color: #9e9e9e;
}
.iconColor:hover {
  color: #fafafa;
}
.vTooltip {
  width: 256px;
}
</style>